import { css } from '@emotion/react'
import { Icon, IconImage, Tooltip } from 'bold-ui'
import { IconColor } from 'bold-ui/lib/components/Icon/Icon'

type PerguntaSelectListItemStatus = 'INFO' | 'WARNING'

interface ConsultaSeguimentoPerguntaSelectListItemStatusProps {
  status: PerguntaSelectListItemStatus | null
}

export function ConsultaSeguimentoPerguntaSelectListItemStatus(
  props: Readonly<ConsultaSeguimentoPerguntaSelectListItemStatusProps>
) {
  const { status } = props

  if (!status) {
    return null
  }

  const { fill, icon, tooltipText } = STATUS_MAP[status]

  return (
    <Tooltip text={tooltipText}>
      <Icon size={1} icon={icon} fill={fill} style={styles.root} />
    </Tooltip>
  )
}

const STATUS_MAP: Record<PerguntaSelectListItemStatus, { icon: IconImage; fill: IconColor; tooltipText: string }> = {
  INFO: {
    fill: 'primary',
    icon: 'chatOutline',
    tooltipText: 'Esta pergunta tem respostas registradas.',
  },
  WARNING: {
    fill: 'alert',
    icon: 'exclamationTriangleOutline',
    tooltipText: 'As respostas já registradas serão descartadas.',
  },
}

const styles = {
  root: css`
    margin-bottom: -0.25rem;
    margin-left: 0.25rem;
  `,
}
